export type SimpleSource =
  | "facebook"
  | "instagram"
  | "tiktok"
  | "threads"
  | "google"
  | "social"
  | "referral"
  | "direct"
  | "catalog";

const SOCIAL_HOSTS = [
  "facebook.com", "m.facebook.com", "l.facebook.com", "lm.facebook.com", "fb.com",
  "instagram.com", "l.instagram.com",
  "tiktok.com", "threads.net", "twitter.com", "x.com", "linkedin.com", "pinterest.com",
];

const GOOGLE_HOSTS = ["google.", "google.com", "google.pl", "googleusercontent.com"];

function hostIncludes(host: string, needles: string[]) {
  const h = host.toLowerCase();
  return needles.some(n => h.includes(n));
}

export function detectSimpleSource(
  urlSearch: string = window.location.search,
  referrer: string = document.referrer
): SimpleSource {
  const params = new URLSearchParams(urlSearch);

  const sourceParam = (params.get("source") || "").toLowerCase();
  if (sourceParam === "catalog") {
    return "catalog";
  }

  const utmSource = (params.get("utm_source") || "").toLowerCase();
  const utmMedium = (params.get("utm_medium") || "").toLowerCase();

  if (utmSource) {
    if (["facebook", "meta"].includes(utmSource)) return "facebook";
    if (utmSource === "instagram") return "instagram";
    if (utmSource === "tiktok") return "tiktok";
    if (utmSource === "threads") return "threads";
    if (utmSource === "google" || utmSource.includes("google")) return "google";
    if (["ig", "fb"].includes(utmSource)) return "social";
  }
  if (utmMedium && ["social", "paid-social"].includes(utmMedium)) {
    // Check referrer below to try to be more specific.
  }

  if (referrer) {
    try {
      const refHost = new URL(referrer).hostname;

      if (refHost.includes("facebook." ) || refHost === "fb.com") return "facebook";
      if (refHost.includes("instagram.")) return "instagram";
      if (refHost.includes("tiktok.")) return "tiktok";
      if (refHost.includes("threads.")) return "threads";
      if (hostIncludes(refHost, GOOGLE_HOSTS)) return "google";

      if (hostIncludes(refHost, SOCIAL_HOSTS)) return "social";

      if (refHost && refHost !== window.location.hostname) return "referral";
    } catch (error) {
      console.error("Failed to parse referrer for source detection", { referrer, error });
    }
  }

  return "direct";
}
